import { WorkareaGroupWithWorkareas } from '../../domain/workareas/group'
import { WorkareaPricingPreview } from '../../domain/workareas/workareaPricingApi'
import { PricingTypes } from '../../common/constants'
import { EstimatedItem, isEstimatedItem } from '../../domain/workareaItem'
import { ChangeSet, getUpdatedItem, ItemWorkareaData } from './itemModel'

export const buildPricingPreviewRequests = (workareas: ItemWorkareaData[], estimatedItems: EstimatedItem[], changeSet: ChangeSet) => {
  const items = estimatedItems.concat(changeSet.addedItems.filter(isEstimatedItem))
    .map(item => getUpdatedItem(item, changeSet))
    .filter(item => !item.isDeleted)
    .map(item => item.item)
  return workareas.filter(workarea => workarea.pricing).map(workarea => ({
    workareaId: workarea.id,
    pricing: workarea.pricing,
    isApproved: workarea.isApproved,
    request: {
      workSubtotal: Math.round(items.filter(item => item.workareaId === workarea.id)
        .reduce((total, item) => total + item.totalPrice, 0)
        * (workarea.pricingType === PricingTypes.PerVisit ? 1 : workarea.estimatedOccurrences ?? 1)),
      customerTotal: workarea.customQuotedPrice ?? null,
    },
  }))
}

export const applyWorkareaPricingPreviews = (
  workareas: ItemWorkareaData[],
  previews: { workareaId: number, pricing?: WorkareaPricingPreview }[]
): ItemWorkareaData[] => workareas.map(workarea => {
  const preview = previews.find(x => x.workareaId === workarea.id)?.pricing
  if (!preview || !workarea.pricing) {
    return workarea
  }
  const hasQuote = workarea.pricingType === PricingTypes.QuotedPrice || workarea.pricingType === PricingTypes.PerVisit
  return {
    ...workarea,
    quotedPrice: hasQuote ? preview.estimated.customerTotal : workarea.quotedPrice,
    recovery: hasQuote ? preview.estimated.recovery : workarea.recovery,
    pricing: { ...workarea.pricing, estimated: preview.estimated, calculatedEstimate: preview.calculatedEstimate },
  }
})

export const mergeServerPricingOntoWorkareas = (workareas: ItemWorkareaData[], groups: WorkareaGroupWithWorkareas[]): ItemWorkareaData[] => {
  const savedWorkareas = groups.flatMap(group => group.workareas)
  return workareas.map(workarea => {
    const saved = savedWorkareas.find(x => x.id === workarea.id)
    return saved?.pricing ? { ...workarea, pricing: saved.pricing, recovery: saved.recovery,
      quotedPrice: saved.quotedPrice, customQuotedPrice: saved.customQuotedPrice ?? undefined } : workarea
  })
}
